// extracted by css-extract-rspack-plugin
export default {"cls1":"PapersSearch-cls1_EXx","cls2":"PapersSearch-cls2_gGC PapersSearch-cls1_EXx"};